module.exports = __webpack_public_path__ + "static/media/Rock_suite.62c4c03c.jpeg";